import { ProfileSectionProps } from "./types";
import { FormSection } from "@/features/common/components/FormSection";
import { DataField } from "@/features/common/components/DataField";
import { WorkPermitStatusFields } from "./WorkPermit/WorkPermitStatusFields";
import { WorkPermitDetailFields } from "./WorkPermit/WorkPermitDetailFields";

// Label mapping functions
const getResidencePermitStatusLabel = (value: string) => {
  const labels: { [key: string]: string } = {
    not_applied: "Nicht beantragt",
    applied: "Beantragt",
    granted: "Erteilt"
  };
  return labels[value] || value;
};

const getResidencePermitTypeLabel = (value: string) => {
  const labels: { [key: string]: string } = {
    skilled_worker_recognition: "Fachkraft in Anerkennung (§16d AufenthG)",
    recognized_skilled_worker: "Anerkannte Fachkraft (§18a / §18b AufenthG)",
    auxiliary_worker_recognition:
      "Hilfskraft während der Anerkennung (§19c Abs. 1 i.V.m. §6 BeschV)",
    vocational_training: "Berufsausbildung (§16a AufenthG)",
    language_course: "Sprachkurs vor Ausbildung (§16g AufenthG)",
    eu_blue_card: "EU Blaue Karte",
    other_employment: "Aufenthaltserlaubnis für sonstige Beschäftigung",
    settlement_permit: "Niederlassungserlaubnis",
    family_reunion: "Aufenthaltserlaubnis für Familienangehörige",
    asylum_permit: "Aufenthaltsgestattung (Asyl)",
    toleration: "Duldung",
    other: "Andere"
  };
  return labels[value] || value;
};

export function WorkPermitSection({
  profile,
  setProfile,
  loading,
  readOnly
}: ProfileSectionProps) {
  const residencePermitStatus = profile?.residence_permit_status || "";
  const showDetailsFields = residencePermitStatus === "granted";

  return (
    <FormSection title="Arbeitserlaubnis & Aufenthaltstitel">
      <div className="space-y-4">
        <WorkPermitStatusFields
          profile={profile}
          setProfile={setProfile}
          loading={loading}
          readOnly={readOnly}
        />

        {showDetailsFields && (
          <WorkPermitDetailFields
            profile={profile}
            setProfile={setProfile}
            loading={loading}
            readOnly={readOnly}
          />
        )}
      </div>
    </FormSection>
  );
}

// View component
export function WorkPermitView({ profile }: { profile: any }) {
  return (
    <div className="space-y-1">
      <DataField label="Einreisedatum" value={profile.entry_date} />
      <DataField
        label="Aufenthaltstitel Status"
        value={
          profile.residence_permit_status
            ? getResidencePermitStatusLabel(profile.residence_permit_status)
            : null
        }
      />
      <DataField
        label="Aufenthaltstitel"
        value={
          profile.residence_permit_type
            ? getResidencePermitTypeLabel(profile.residence_permit_type)
            : null
        }
      />
      <DataField label="Gültig bis" value={profile.residence_permit_validity} />
    </div>
  );
}
